import ReceiveTransferListing from "./receiveTransferListing.container";

export default ReceiveTransferListing;
